import styled from '@emotion/styled';
import { useState } from 'react';
import { mergeProps, useButton, useFocus } from 'react-aria';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';

import { DeviceSettingsGeneralQuickActionOverrideIcon } from './DeviceSettingsGeneralQuickActionOverrideSelectOption';

export function DeviceSettingsGeneralQuickActionOverrideSelectPreview(props) {
  const button = useButton(props.select.triggerProps, props.previewRef);

  const [isFocused, setIsFocused] = useState(false);
  const focus = useFocus({
    onFocusChange: setIsFocused,
    onBlur: props.onBlur,
  });

  return (
    <S.Input
      {...mergeProps(button.buttonProps, focus.focusProps)}
      ref={props.previewRef}
      title={props.state.selectedItem?.textValue}
      data-is-open={props.state.isOpen}
      data-is-focused={isFocused}
    >
      <S.Value {...props.select.valueProps}>
        <DeviceSettingsGeneralQuickActionOverrideIcon value={props.state.selectedItem?.value} />
        <S.Name>{props.state.collection?.size > 0 && props.state.selectedItem?.textValue}</S.Name>
      </S.Value>
      <S.ChevronDownIcon
        source={glyph.core.chevronDownBold}
        color={theme.color.icon_light}
        size={theme.icon.size_small}
      />
    </S.Input>
  );
}

function S() {}
DeviceSettingsGeneralQuickActionOverrideSelectPreview.S = S;

S.Input = styled.button`
  position: relative;
  display: inline-grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  grid-gap: ${su(1)};
  min-width: 0;
  width: 100%;
  height: 40px;
  padding: 3px ${su(1)};
  background-color: ${theme.color.component};
  border: 1px solid ${theme.input.border};
  outline: 0;
  cursor: pointer;
  border-radius: ${theme.input.border_radius};

  &[data-is-open='true'],
  &[data-is-focused='true'] {
    border: 1px solid ${theme.input.border_focus};
  }
`;

S.Value = styled.span`
  display: flex;
  align-items: center;
  gap: ${su(1.5)};
  min-width: 0;
  width: 100%;
  overflow: hidden;
`;

S.Name = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
`;

S.ChevronDownIcon = styled(Glyph)`
  flex: 0 0 ${theme.icon.size_tiny};
`;
